/**
 * ApolloClient singleton.
 * @todo change the URI to change between devmode (localhost) and prod (/graphql)
 */
import { ApolloClient, createNetworkInterface } from "react-apollo";

export default new ApolloClient({
    networkInterface: createNetworkInterface({
        uri:
            process.env.NODE_ENV === "development"
                ? "http://localhost:8080/graphql"
                : "/graphql",
    }),
    dataIdFromObject: (o: { id?: string }) => o.id,
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/client.ts